import { consts } from '@allesauto/utils/consts';
import Cookies from 'js-cookie';

import { refreshLoginTokens } from '@/global/auth/auth';
import {
  LoginToken,
  USER_LOGIN,
  USER_LOGIN_SAVE_TOKEN,
  USER_LOGOUT,
} from '@/store/redux/actions/user';

import { IReduxActionProps } from './../../Utils/index';
import { RootState } from '../..';

export interface UserState {
  isLoggedIn: boolean;
}

const initialState: UserState = {
  isLoggedIn: false,
};

let refreshInterval: ReturnType<typeof setInterval>;
let expiryDate: Date;

const writeLoginCookie = (obj: LoginToken) => {
  const expiryDate = new Date(obj?.expiresAt);

  Cookies.set(consts.COOKIES.USER_TOKEN, JSON.stringify(obj), {
    path: '/',
    expires: expiryDate,
    sameSite: 'strict',
    secure: process.env.NODE_ENV !== 'development', // don't set it to true on localhost, otherwise it doesn't work in safari
  });
};

// Start a refresh token timer (based on expiry timestamp from the cookie)
const startRefreshTokenTimer = () => {
  const twoMin = 120000;

  // Periodically check whether the expiry timestamp of the token was reached
  refreshInterval = setInterval(() => {
    const userTokenCookie = Cookies.get(consts.COOKIES.USER_TOKEN);
    const nowTimestamp = new Date().getTime();
    // Guard time of 15min (before expiry time)
    const fifteenMin = 900000;
    const expiryTimestamp = expiryDate.getTime() - fifteenMin;
    const isExpired = expiryTimestamp < nowTimestamp;

    if (userTokenCookie) {
      const userTokenObj: LoginToken = JSON.parse(userTokenCookie);

      if (isExpired && userTokenObj?.refreshToken) {
        refreshLoginTokens(userTokenObj.refreshToken)
          .then((response: LoginToken) => {
            expiryDate = new Date(response.expiresAt);

            writeLoginCookie(response);
          })
          .catch(() => {
            // Global error
            clearInterval(refreshInterval);
          });
      }
    } else {
      clearInterval(refreshInterval);
    }
  }, twoMin);
};

const User = (state: UserState = initialState, action: IReduxActionProps) => {
  switch (action.type) {
    case USER_LOGIN: {
      const expiryString: unknown = action.payload;
      expiryDate = new Date(expiryString as string);

      startRefreshTokenTimer();

      return {
        ...state,
        isLoggedIn: true,
      };
    }

    case USER_LOGIN_SAVE_TOKEN: {
      expiryDate = new Date(action.payload?.expiresAt);

      writeLoginCookie(action.payload as LoginToken);
      startRefreshTokenTimer();

      return {
        ...state,
        isLoggedIn: true,
      };
    }

    case USER_LOGOUT: {
      Cookies.remove(consts.COOKIES.USER_TOKEN);
      clearInterval(refreshInterval);

      return {
        ...state,
        isLoggedIn: false,
      };
    }

    default:
      return state;
  }
};

export const selectIsUserLoggedIn = (state: RootState) => state.user.isLoggedIn;

export default User;
